import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MatTooltip } from '@angular/material/tooltip';
import { IconComponent } from '@examdojo/core/icon';
import { MatTooltipTruncateDirective } from '@examdojo/core/mat-tooltip-truncate';
import { UntilDestroy } from '@ngneat/until-destroy';
import { TreeNode, TreeNodeMetadata } from '../tree-node.model';

@UntilDestroy()
@Component({
  selector: 'dojo-selectable-tree-cell',
  standalone: true,
  imports: [IconComponent, MatTooltipTruncateDirective, MatTooltip, MatCheckboxModule],
  templateUrl: './selectable-tree-cell.component.html',
  styleUrls: ['./selectable-tree-cell.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SelectableTreeCellComponent<OriginalData = unknown, Metadata extends TreeNodeMetadata | void = void> {
  readonly node = input.required<TreeNode<OriginalData, Metadata>>();
  readonly expanded = input(false);
  readonly selected = input(false);
  readonly indeterminate = input(false);
  readonly nestingLevel = input(0);
  readonly isGroup = input(false);

  readonly checkboxChange = output<MatCheckboxChange>();

  protected readonly onCheckboxChangeHandler = (event: MatCheckboxChange) => {
    this.checkboxChange.emit(event);
  };
}
